<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>门诊预约问诊管理</el-breadcrumb-item>
        <el-breadcrumb-item>专家管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="专家名称：" prop="name">
          <el-input v-model="listParams.name" placeholder="请填写医生名称"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button @click="loadTableData" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button @click="openDialog" type="primary">新增</el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="600" border>
          <el-table-column fixed align="center" width="60" label="序号">
            <template slot-scope="scope">
              <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
            </template>
          </el-table-column>
          <el-table-column label="医生名称" prop="name" align="center"></el-table-column>
          <el-table-column label="医生头像" prop="avatar" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.avatar" alt="" class="avatar" />
            </template>
          </el-table-column>
          <el-table-column label="职位" prop="title" align="center"></el-table-column>
          <el-table-column label="所属医院" prop="hospitalName" align="center"></el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
              <confirm-button type="text" style="margin: 0 10px" title="确认要删除该医生吗？" @confirmed="deleteItem(scope.row.id)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" @close="$refs['dialogForm'].resetFields()" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules">
        <el-form-item label="医生名称：" prop="name">
          <el-input v-model="dialogForm.name" placeholder="请填写医生名称" maxlength="30"></el-input>
        </el-form-item>

        <el-form-item label="头像：" prop="avatar">
          <div class="upload-thumbnail">
            <div class="upload-thumbnail-img" :loading="uploading">
              <i class="el-icon-circle-plus-outline upload-icon"></i>
              <input type="file" class="hidden-upload" @change="doUpload" id="uploadDom" />
            </div>
            <div class="preview" v-if="dialogForm.avatar">
              <img :src="dialogForm.avatar" alt="" />
            </div>
          </div>
        </el-form-item>

        <el-form-item label="性别：" prop="sex">
          <el-radio-group v-model="dialogForm.sex">
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="职位：" prop="title">
          <el-input v-model="dialogForm.title" placeholder="请填写职位" maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="学历：" prop="education">
          <el-select v-model="dialogForm.education" placeholder="请选择学历" style="width: 100%">
            <el-option label="学士" :value="0"></el-option>
            <el-option label="硕士" :value="1"></el-option>
            <el-option label="博士" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业擅长：" prop="subject">
          <el-input v-model="dialogForm.subject" placeholder="请填写专业擅长"></el-input>
        </el-form-item>

        <el-form-item label="所属分类：" prop="departmentIds">
          <el-cascader
            v-model="dialogForm.departmentIds"
            style="width: 100%"
            :options="options"
            :props="{
              value: 'id',
              label: 'name',
              children: 'subDepartments',
            }"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="所属医院：" prop="hospitalId">
          <el-select v-model="dialogForm.hospitalId" style="width: 100%">
            <el-option v-for="(item, index) in hospitalList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="专家简介：" prop="description">
          <RichTextarea v-if="dialogVisible" class="wang-editor-style" v-model="dialogForm.description" />
        </el-form-item>

        <el-form-item label="" style="text-align: center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button @click="saveDialog('dialogForm')" type="primary" :disabled="isDisabled">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      listParams: {
        name: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      tableData: [],
      dialogVisible: false,
      options: [],
      dialogForm: {
        name: "",
        avatar: "",
        sex: 0,
        title: "",
        education: "",
        subject: "",
        departmentIds: [],
        hospitalId: "",
        description: "",
      },
      dialogRules: {
        name: [{ required: true, message: "请填写医生名称", trigger: "blur" }],
        avatar: [{ required: true, message: "请上传医生头像", trigger: "change" }],
        title: [{ required: true, message: "请填写医生职位", trigger: "blur" }],
        departmentIds: [{ required: true, message: "请选择所属科室", trigger: "change" }],
        hospitalId: [{ required: true, message: "请选择所属医院", trigger: "change" }],
        description: [{ required: true, message: "请填写专家简介", trigger: "blur" }],
      },
      uploading: false,
      hospitalList: [],
      isDisabled: false,
    };
  },
  mounted() {
    this.loadTableData();
    this.loadTreeList();
    this.loadHospitalList();
  },
  methods: {
    loadTableData() {
      this.tableLoading = true;
      const listParams = Object.assign(this.listParams, this.pager);
      this.$http({
        url: global.apiUrl + "/medical/doctor/list",
        method: "GET",
        params: listParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableData = res.body.data.dataList;
            this.pager.total = res.body.data.total;
          } else {
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    /**
     * @description: 加载树形结构
     * @param {*}
     * @return {*}
     */
    loadTreeList() {
      this.$http({
        url: global.apiUrl + "/medical/department/list",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const treeList = res.body.data;
            if (treeList && treeList.length > 0) {
              this.options = this.recursive(treeList);
              console.log(this.options);
            }
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 递归赋值
     * @param {*} treeList
     * @return {*}
     */
    recursive(treeList) {
      return treeList.map(item => {
        if (item.subDepartments.length === 0) {
          delete item.subDepartments;
        } else {
          this.recursive(item.subDepartments);
        }
        return item;
      });
    },
    /**
     * @description: 加载医院
     * @param {*}
     * @return {*}
     */
    loadHospitalList() {
      this.$http({
        url: global.apiUrl + "/medical/hospital/search",
        method: "GET",
        params: {
          name: "",
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.hospitalList = res.body.data;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 编辑医生
     * @param {*} id
     * @return {*}
     */
    editItem(id) {
      this.$http
        .get(global.apiUrl + `/medical/doctor/detail?id=${id}`)
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            Object.assign(this.dialogForm, res.body.data);
            this.dialogVisible = true;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 删除医生
     * @param {*} id
     * @return {*}
     */
    deleteItem(id) {
      this.$http
        .delete(global.apiUrl + `/medical/doctor/delete?id=${id}`)
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 上传图片
     */
    doUpload() {
      this.uploading = true;
      const files = document.getElementById("uploadDom").files;
      const file = files[0];

      const params = new FormData();
      params.append("file", file);
      params.append("path", "upload/good-img");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then(res => {
          this.uploading = false;
          this.dialogForm.avatar = res.data.data;
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * 删除图片
     * @param index
     */
    deleteImg(index) {
      this.dialogForm.thumbnail.splice(index, 1);
    },
    /**
     * @description: 保存表单
     * @param {*} name
     * @return {*}
     */
    saveDialog(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isDisabled = true;
          let url = "";
          let method = "";
          if (this.dialogForm.id) {
            url += global.apiUrl + "/medical/doctor/edit";
            method += "PUT";
          } else {
            url += global.apiUrl + "/medical/doctor/save";
            method += "POST";
          }
          this.$http({
            url: url,
            method: method,
            body: this.dialogForm,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.isDisabled = false;
                this.dialogForm = this.$options.data().dialogForm;
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              console.error(err);
              this.isDisabled = false;
            });
        }
      });
    },
    openDialog() {
      this.dialogForm = this.$options.data().dialogForm;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 60px;
  height: 60px;
}
.wang-editor-style {
  margin-top: 10px;
}
.upload-thumbnail {
  display: flex;
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 100px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 40px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
  }
  .preview {
    width: 100px;
    height: 100px;
    border: 1px solid #ebeef5;
    margin-left: 10px;
    position: relative;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
